import { render, staticRenderFns } from "./preview_6.vue?vue&type=template&id=4c68b0f4&scoped=true"
import script from "./preview_6.vue?vue&type=script&lang=js"
export * from "./preview_6.vue?vue&type=script&lang=js"
import style0 from "./preview_6.vue?vue&type=style&index=0&id=4c68b0f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c68b0f4",
  null
  
)

export default component.exports